import React from 'react'
import Layout from '../../components/Layout'
import DownloadStyle from '../Download/DownloadStyle'
import { Spin } from 'antd'
import Button from '../../components/Button'
import { Phone } from 'lucide-react'
import html2PDF from 'html2pdf.js'
import { useLocation } from 'react-router-dom'
import moment from 'moment'

export default function AlertMessageUZ() {
	const location = useLocation()
	const today = moment().format('DD/MM/YYYY')
	const { state } = location
	console.log(state)

	const formatter = new Intl.NumberFormat('ru-RU', {
		minimumFractionDigits: 0,
		maximumFractionDigits: 3,
	})

	const download = () => {
		let element = document.getElementsByClassName('ogohlantirsh-xati')[0]

		// Set A4 width minus margins to prevent text cutoff
		const a4WidthMm = 210
		const marginMm = 6 // 1cm on each side
		const contentWidthMm = a4WidthMm - marginMm * 2

		element.style.width = `${contentWidthMm}mm`
		element.style.maxWidth = '100%'
		element.style.boxSizing = 'border-box'

		html2PDF(element, {
			margin: [6, 6, 6, 6], // 1cm margins on all sides
			filename: 'ogohlantirsh-xati.pdf',
			image: { type: 'jpeg', quality: 0.98 },
			html2canvas: {
				scale: 2,
				logging: false,
				letterRendering: true,
				useCORS: true,
			},
			jsPDF: {
				unit: 'mm',
				format: 'a4',
				orientation: 'portrait',
			},
		})
	}

	return (
		<Layout>
			<DownloadStyle style={{ backgroundColor: '#fff' }}>
				<Spin spinning={false}>
					<main className="max-w-[740px] flex flex-col gap-3 w-full mx-auto p-3 rounded-md">
						<div className="flex justify-end">
							<Button btnStyle={{ width: 150 }} onClick={download}>
								Xatni yuklash
							</Button>
						</div>
						<div className="max-w-[740px] flex flex-col gap-3 w-full mx-auto p-3 rounded-md ogohlantirsh-xati">
							<h1 className="text-xl font-bold text-center">
								CREDOMOBILEUZ{' '}
								<span className="block uppercase">
									РАСМИЙ ОГОҲЛАНТИРИШ ХАТИ
								</span>
							</h1>
							<div className="flex flex-col gap-1">
								<h2 className="text-md font-bold">
									Ҳужжат рақами:{' '}
									<b className="text-red-500">
										CM/{today.split('/')[2]}/{state.docNum}
									</b>
								</h2>
								<h3 className="text-md">
									<b>Сана: </b>
									{today} йил
								</h3>
							</div>
							<div className="flex flex-col gap-0 mt-3.5">
								{/* <div className="flex flex-row items-center text-md font-semibold">
									<span>Hurmatli mijoz</span>
									<span>{state.cardName}</span>
									<span>siz</span>
								</div> */}
								<b className="text-md text-center">
									Ҳурматли мижоз {state.cardName} сиз “CREDOMOBILEUZ” техника
									дўконидан муддатли тўлов шартномаси асосида олган техника
									воситаси учун келишилган тўловларни ўз вақтида
									тўламаганлигингиз аниқланди.
								</b>
							</div>
							<div className="flex flex-col gap-1 mt-3.5 font-medium">
								<b className="text-md">Ҳозирги ҳолат: </b>
								<div className="grid grid-cols-2 mt-3.5 text-md font-bold">
									<div className="flex flex-col gap-0">
										<span>Тизимимизда сизнинг ҳисобингизда</span>
										<span>муддати ўтган қарздорлик мавжуд.</span>
									</div>
									<span>
										{formatter.format(state.debtUntilToday)} АҚШ доллари
										миқдорида
									</span>
								</div>
								<div className="grid grid-cols-2 mt-3.5 text-md font-bold">
									<div className="flex flex-col gap-0">
										<span>Умумий қарздорлик:</span>
									</div>
									<span>
										{formatter.format(state.debtTotal)} АҚШ доллари миқдорида.
									</span>
								</div>
							</div>
							<div className="flex flex-col gap-1 mt-3.5">
								<h1 className="text-xl font-bold text-center">
									ОГОҲЛАНТИРАМИЗ
								</h1>
								<p
									className="mt-3.5"
									style={{
										textIndent: 30,
									}}
								>
									Сиз имзолаган шартнома асосида ойлик тўловларни ўз вақтида
									амалга оширишингиз шарт. Қарздорлик тўлиқ ёпилмагунча сотиб
									олинган техника <b>CREDOMOBILE</b> гаровида қолади
								</p>
								<p
									className="font-bold mt-3.5"
									style={{
										textIndent: 30,
									}}
								>
									Ушбу огоҳлантириш хати қабул қилинганданидан бошлаб 3 иш куни
									ичида қарзингизни тўлиқ тўламасангиз, қуйидаги чоралар
									кўрилади
								</p>
								<p className="mt-3.5">
									1. Ўзбекистон Республикаси қонунчилигига мувофиқ,{' '}
									<b>
										банк ҳисоб рақамингиз ва шахсий банк карталарингиздан
										қарздорлик суммасини мажбурий ундириш
									</b>{' '}
									бўйича иш юритиш бошланади.
								</p>
								<p className="mt-3.5">
									2. Қарздорлик бўйича иш юритиш учун{' '}
									<b>
										маҳалла, профилактика инспектори ва бошқа тегишли органларга
										мурожаат қилинади.
									</b>
								</p>
								<p className="mt-3.5">
									3. Қарздорлик ҳақидаги маълумотлар{' '}
									<b>молиявий тарихингизга салбий таъсир кўрсатади.</b>
								</p>
							</div>
							<div className="w-full h-[1px] bg-black/80 mt-5" />
							<h2
								className="mt-2 font-bold text-md"
								style={{
									textIndent: 8,
								}}
							>
								<span className="text-red-500 font-extrabold">!</span> Илтимос,
								ушбу огоҳлантириш хатига жиддий ёндашинг ва 3 иш куни ичида
								қарздорлик бўйича тўловларни амалга оширинг.
							</h2>
							<div className="mt-3.5 flex flex-col gap-1">
								<b>Қўшимча маълумот учун:</b>
								<div className="flex flex-col gap-0">
									<span>Тел: {state.u_dunner_phone_number}</span>
									<span>Тел: {state.officeExtension}</span>
									<span>Телеграм: {state.u_dunner_telegram_name}</span>
								</div>
							</div>
						</div>
					</main>
				</Spin>
			</DownloadStyle>
		</Layout>
	)
}
